import uuid from 'react-uuid';
import { create } from 'zustand';
import { PilotCertificateCoastalSegmentGroupProps } from '../props';

export interface IMapStoreState {
    mapId: string;
    config: any | null;
    showAis: boolean;
    isAisActive: boolean;
    zoom: number;
    center: any | null;
    bounds: any | null;
    dragStart: string | null,
    dragEnd: any | null,
    resize: any | null;
    segmentIds: number[];
    segmentGroupIds: number[];
    pilotageLoaded: string | null;
    shipPositionLoaded: string | null;
    selectShipPosition: any | null;
    showInfo: any | null;
    showDialog: any | null;
    selectLocation: any | null;
    showLocations: boolean;
    activateSeamap: boolean;
    showLegend: boolean;
    showLoader: boolean;
    dataClicked: any | null;
    activateMultiSelect: boolean;
    featureMouseOver: any | null;
    featureMouseOut: any | null;
    mapTitle: string | null;
    panelState: string | null;
    mapClicked: any | null;
    selectedCoastalSegmentGroup: any | null;
    selectedLocation: any | null;
    pilotCertificateCoastalSegmentPerson: any | null;
    excludeLocationIds: number[],
    showLocationType: boolean,
    coastalSegmentGroups: PilotCertificateCoastalSegmentGroupProps[] | null;
    showLocationQuayManual: boolean;
    pilotCertificateToggleFeatures: boolean;
    selectedPilotCoastalSegmentGroup: any | null;

    setConfig: (data: any | null) => void;
    setIsAisActive: (data: boolean) => void;
    setZoom: (data: number) => void;
    setCenter: (data: any | null) => void;
    setBounds: (data: any | null) => void;
    setDragStart: () => void;
    setDragEnd: (data: any) => void;
    setResize: (data: any | null) => void;
    setSegmentIds: (data: number[]) => void;
    setSegmentGroupIds: (data: number[]) => void;
    setPilotageLoaded: () => void;
    setShipPositionLoaded: () => void;
    setSelectShipPosition: (data: any | null) => void;
    setShowInfo: (data: any | null) => void;
    setShowDialog: (data: any | null) => void;
    setSelectLocation: (data: any | null) => void;
    setShowLocations: (data: boolean) => void;
    setActivateSeamap: (data: boolean) => void;
    setShowLegend: (data: boolean) => void;
    setShowLoader: (data: boolean) => void;
    setDataClicked: (data: any | null) => void;
    setActivateMultiSelect: (data: boolean) => void;
    setFeatureMouseOver: (data: any | null) => void;
    setFeatureMouseOut: (data: any | null) => void;
    setMapTitle: (data: string | null) => void;
    setPanelState: (data: string | null) => void;
    setMapClicked: (data: any | null) => void;
    setSelectedCoastalSegmentGroup: (data: any | null) => void;
    setSelectedLocation: (data: any | null) => void;
    setPilotCertificateCoastalSegmentPerson: (data: any | null) => void;
    setExcludeLocationIds: (data: number[] | null) => void;
    setShowLocationType: (data: boolean) => void;
    setCoastalSegmentGroups: (data: PilotCertificateCoastalSegmentGroupProps[] | null) => void;
    setShowLocationQuayManual: (data: boolean) => void;
    setPilotCertificateToggleFeatures: (data: boolean) => void;
    setSelectedPilotCoastalSegmentGroup: (data: any | null) => void;
}

export const createMapStore = (initialState: Partial<IMapStoreState>) =>
    create<IMapStoreState>((set) => ({
        mapId: uuid(),
        showAis: initialState?.showAis ?? false,

        config: null,
        isAisActive: false,
        showInfo: null,
        showDialog: null,
        showLocations: false,
        activateSeamap: false,
        showLegend: false,
        showLoader: false,

        zoom: 0,
        center: null,
        bounds: null,
        dragStart: null,
        dragEnd: null,
        resize: null,
        segmentIds: [],
        segmentGroupIds: [],

        pilotageLoaded: null,
        shipPositionLoaded: null,
        selectShipPosition: null,
        
        selectLocation: null,
        dataClicked: null,
        activateMultiSelect: false,
        featureMouseOver: 0,
        featureMouseOut: null,
        mapTitle: null,
        panelState: null,
        mapClicked: null,
        selectedCoastalSegmentGroup: null,
        selectedLocation: null,
        pilotCertificateCoastalSegmentPerson: null,
        excludeLocationIds: [],
        showLocationType: false,
        coastalSegmentGroups: [],
        showLocationQuayManual: true,
        pilotCertificateToggleFeatures: false,
        selectedPilotCoastalSegmentGroup: null,

        setConfig: (data) => set({ config: data }),
        setIsAisActive: (data) => set({ isAisActive: data }),
        setZoom: (data) => set({ zoom: data }),
        setCenter: (data) => set({ center: data }),
        setBounds: (data) => set({ bounds: data }),
        setDragStart: () => set({ dragStart: uuid() }),
        setDragEnd: (data) => set({ dragEnd: data }),
        setResize: (data) => set({ resize: data }),
        setSegmentIds: (data) => set({ segmentIds: data }),
        setSegmentGroupIds: (data) => set({ segmentGroupIds: data }),
        setPilotageLoaded: () => set({ pilotageLoaded: uuid() }),
        setShipPositionLoaded: () => set({ shipPositionLoaded: uuid() }),
        setSelectShipPosition: (data) => set({ selectShipPosition: data }),
        setShowInfo: (data) => set({ showInfo: data }),
        setShowDialog: (data) => set({ showDialog: data }),
        setSelectLocation: (data) => set({ selectLocation: data }),
        setShowLocations: (data) => set({ showLocations: data }),
        setActivateSeamap: (data) => set({ activateSeamap: data }),
        setShowLegend: (data) => set({ showLegend: data }),
        setShowLoader: (data) => set({ showLoader: data }),
        setDataClicked: (data) => set({ dataClicked: data }),
        setActivateMultiSelect: (data) => set({ activateMultiSelect: data }),
        setFeatureMouseOver: (data) => set({ featureMouseOver: data }),
        setFeatureMouseOut: (data) => set({ featureMouseOut: data }),
        setMapTitle: (data) => set({ mapTitle: data }),
        setPanelState: (data) => set({ panelState: data }),
        setMapClicked: (data) => set({ mapClicked: data }),
        setSelectedCoastalSegmentGroup: (data) => set({ selectedCoastalSegmentGroup: data }),
        setSelectedLocation: (data) => set({ selectedLocation: data }),
        setPilotCertificateCoastalSegmentPerson: (data) => set({ pilotCertificateCoastalSegmentPerson: data }),
        setExcludeLocationIds: (data) => set({ excludeLocationIds: data }),
        setShowLocationType: (data) => set({ showLocationType: data }),
        setCoastalSegmentGroups: (data) => set({ coastalSegmentGroups: data }),
        setShowLocationQuayManual: (data) => set({ showLocationQuayManual: data }),
        setPilotCertificateToggleFeatures: (data) => set({ pilotCertificateToggleFeatures: data }),
        setSelectedPilotCoastalSegmentGroup: (data) => set({ selectedPilotCoastalSegmentGroup: data }),
    }));
